import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ValveReleaseOption {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class ValveReleaseFilterService {
  private readonly baseUrl: string = environment.pipingApiEndpoint;

  constructor(private readonly http: HttpClient) {}

  getValveReleases(businessUnitId: string, applicationId: string): Observable<ValveReleaseOption[]> {
    if (!businessUnitId || !applicationId) {
      return of([]);
    }

    const params: HttpParams = new HttpParams()
      .set('businessUnitId', businessUnitId)
      .set('applicationId', applicationId);

    return this.http
      .get<ValveReleaseOption[]>(`${this.baseUrl}/Release/wizard/valve-releases`, { params })
      .pipe(catchError(() => of([])));
  }
}
